import { gql } from '@apollo/client';

export default gql`
  query getSuggestions($category: String, $status: String) {
    getSuggestions(category: $category, status: $status) {
      ok
      error
      data {
        _id
        branch
        title
        desc
        category
        priority
        status
        response
        responseDate
        responseBy
        employeeId
        employeeName
        employeeNameAr
        departmentId
        attachments {
          filename
          filetype
          url
          size
        }
        userId
        createdAt
        updatedAt
      }
    }
  }
`;
